import styled from 'styled-components';

import media from '~/utils/media';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4%;
`;

export const CountWrap = styled.div`
  display: flex;
  height: 68%;
  font-family: 'LAB디지털';
  font-size: 40px;

  position: absolute;
  top: 10%;
  right: 19.5%;
  color: #8195c5;

  ${media.pcLarge`
    font-size: 114px;
  `}

  ${media.tabletLarge`
    font-size: 112px;
  `}

  ${media.tabletSmall`
    font-size: 112px;
  `}

  ${media.mobileLarge`
    font-size: 17vw;
  `}

  ${media.mobileMid`
    font-size: 17vw;
  `}

  ${media.mobileSmall`
    font-size: 17vw;
  `}

  button {
    padding: 8px;
    border: 1px solid #bbb;
  }
`;

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;

  > button.around {
    width: 54%;
    height: 40%;
    border: 0;
    background: transparent;
    position: absolute;
    top: 44%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const ScoreImg = styled.div`
  width: 90%;
  position: absolute;
  top: 3%;
  left: 50%;
  transform: translateX(-50%);
`;

export const QuizImg = styled.img`
  width: 90%;
  position: absolute;
  left: 50%;
  bottom: 4%;
  transform: translateX(-50%);

  > button {
    width: 38%;
    height: 48%;
    border: 0;
    background: transparent;
    position: absolute;

    &.O {
      top: 42%;
      left: 10%;
    }

    &.X {
      top: 42%;
      right: 10%;
    }
  }
`;

export const AgreeWrap = styled.div`
  width: 45%;
  height: 100%;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 6%;
`;

export const ImgBtn = styled.img`
  width: 44%;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  &.kakao {
    left: 5.5%;
  }

  &.url_copy {
    right: 5.5%;
  }
`;

export const OXBtn = styled.button`
  width: 34%;
  height: 32%;
  border: 0;
  background: transparent;
  position: absolute;

  &.O {
    top: 58%;
    left: 14%;
  }

  &.X {
    top: 58%;
    right: 14%;
  }
`;

export const TestWrap = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 4%;

  > select {
    width: 20%;
    padding: 2%;
  }

  > button {
    padding: 2%;
  }
`;
